import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import FoodItem from "./FoodItem";
import Skeleton from "./Skeleton";
import { foodMenu } from "../../foods";
import {useStateValue} from '../../context/StateProvider'
import NotFound from '../../assets/NotFound.svg'

const Foods = ({addToCart, handleBusket}) => {
  const [menuTab, setMenuTab] = useState("BreakFast");
  const [loading, setLoading] = useState(false)
  const [{foodItems}, dispatch] = useStateValue()
  
  const handleMenuTabs = (type) => {
    setMenuTab(type);
  };

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
        setLoading(false)
    },2000)
},[])

  return (
    <section className="my-12 max-w-screen-xl mx-auto px-6">
      {/* food Menu tab  */}
      {foodItems ? 
      <>
      <div className="flex items-center justify-center space-x-6">
      <p
        className={
          menuTab === "BreakFast"
            ? "active_menu_tab poppins bg-green-800"
            : "menu_tab poppins"
        }
        onClick={() => handleMenuTabs("BreakFast")}
      >
        BreakFast
      </p>
      <p
        className={
          menuTab === "Lunch"
            ? "active_menu_tab poppins bg-green-800"
            : "menu_tab poppins"
        }
        onClick={() => handleMenuTabs("Lunch")}
      >
        Lunch
      </p>
      <p
        className={
          menuTab === "Dinner"
            ? "active_menu_tab poppins bg-green-800"
            : "menu_tab poppins"
        }
        onClick={() => handleMenuTabs("Dinner")}
      >
        Dinner
      </p>
      <p
        className={
          menuTab === "Other"
            ? "active_menu_tab poppins bg-green-800"
            : "menu_tab poppins"
        }
        onClick={() => handleMenuTabs("Other")}
      >
        Other
      </p>
    </div>

    {/* all foods */}
    
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12">
      {foodItems
        .filter((item) => menuTab === item.type)
        .map((item) => (
          loading ? <Skeleton key={item.id}/>: <FoodItem key={item.id} {...item} addToCart={addToCart} item={item} handleBusket={handleBusket}/>
        ))}
    </div>
    </> : <div className="w-full flex "><Skeleton/> <Skeleton/> <Skeleton/></div>
    }
      
    </section>
  );
};

export default Foods;
